export default {
    AUTH: {
        BASE: 'auth.base',
        LOGIN: 'auth.login'
    },
    ACTUALITY: {
        INDEX: 'actuality.index',
        SHOW: 'actuality.show'
    },
    EVENT: {
        INDEX: 'event.index'
    },
    DOCUMENT: {
        BASE: 'document',
        CATEGORY: {
            INDEX: 'document.category.index',
            SHOW: 'document.category.show',
        },
        SUB_CATEGORY: {
            SHOW: 'document.sub_category.show',
        }
    },
    NOTICE: {
        INDEX: 'notice.index',
        SHOW: 'notice.show'
    },
    NOTFOUND: 'not-found',
}